import { ClipboardModule } from '@angular/cdk/clipboard';
import { CdkStepperModule } from '@angular/cdk/stepper';
import { NgModule } from '@angular/core';
import { TrimOnPasteDirective } from '@app/shared/directives/trim-on-paste.directive';
import { SharedModule } from '@app/shared/shared.module';
import { CallBarringModule } from '@business/call-barring/call-barring.module';
import { FeatureModule } from '@business/feature/feature.module';
import { NumberRangeFeaturePageComponent } from '@business/trunk/components/number-range-feature-page/number-range-feature-page.component';
import { TrunkCallBarringPageComponent } from '@business/trunk/components/trunk-call-barring-page/trunk-call-barring-page.component';
import { AddTrunkComponent } from './components/add-trunk/add-trunk.component';
import { AssignUserToTrunkComponent } from './components/assign-user-to-trunk/assign-user-to-trunk.component';
import { ChangeTrunkCredentialsComponent } from './components/change-sip-account/change-trunk-credentials.component';
import { CompareTrunkWithProfileDialogComponent } from './components/compare-trunk-with-profile-dialog/compare-trunk-with-profile-dialog.component';
import { NumberRangePageComponent } from './components/number-range-page/number-range-page.component';
import { NumberRangeTableComponent } from './components/number-range-table/number-range-table.component';
import { TrunkAdvancedFormComponent } from './components/trunk-advanced-form/trunk-advanced-form.component';
import { TrunkCardComponent } from './components/trunk-card/trunk-card.component';
import { TrunkDetailPageComponent } from './components/trunk-detail-page/trunk-detail-page.component';
import { TrunkFeaturePageComponent } from './components/trunk-feature-page/trunk-feature-page.component';
import { TrunkFeaturesComponent } from './components/trunk-features/trunk-features.component';
import { TrunkFormComponent } from './components/trunk-form/trunk-form.component';
import { TrunkNumberFormComponent } from './components/trunk-number-form/trunk-number-form.component';
import { TrunkPageComponent } from './components/trunk-page/trunk-page.component';
import { TrunkPasswordDialogComponent } from './components/trunk-password-dialog/trunk-password-dialog.component';
import { TrunkTeamsSettingsComponent } from './components/trunk-teams-settings/trunk-teams-settings.component';
import { TrunkUserTableComponent } from './components/trunk-user-table/trunk-user-table.component';
import { TrunkUsersPageComponent } from './components/trunk-users-page/trunk-users-page.component';
import { UpdateNumberRangeComponent } from './components/update-number-range/update-number-range.component';

@NgModule({
  imports: [
    SharedModule,
    FeatureModule,
    CdkStepperModule,
    ClipboardModule,
    CallBarringModule,
    TrimOnPasteDirective,
  ],
  declarations: [
    TrunkPageComponent,
    TrunkCardComponent,
    AddTrunkComponent,
    TrunkDetailPageComponent,
    TrunkFormComponent,
    NumberRangePageComponent,
    UpdateNumberRangeComponent,
    TrunkFeaturePageComponent,
    NumberRangeTableComponent,
    NumberRangeFeaturePageComponent,
    TrunkPasswordDialogComponent,
    TrunkAdvancedFormComponent,
    TrunkCallBarringPageComponent,
    TrunkFeaturesComponent,
    AssignUserToTrunkComponent,
    TrunkTeamsSettingsComponent,
    TrunkUsersPageComponent,
    TrunkUserTableComponent,
    TrunkNumberFormComponent,
    CompareTrunkWithProfileDialogComponent,
    ChangeTrunkCredentialsComponent,
  ],
})
export class TrunkModule {}
